import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  PHONE_MASK_INPUT,
  PHONE_MASK_REGEXP,
  PHONE_MASK_REGEXP_NO_SCOPE,
  history,
  validateEmail
} from '../../../../../../helpers'
import {
  BottomLink,
  Grid,
  LinearProgress,
  TextFieldLabel,
  Typography,
} from '../../../../../UI'
import useStyles from './styles'


import {
  getNewEstimateValues,
  getUser,
} from '../../../../../../ducks/selectors'
import { useStepperContext } from '../../../../../../hooks/useStepperContext'

const Company = () => {
  const classes = useStyles()
  const push = history.usePush()
  const user = useSelector(getUser)
  const newEstimate = useSelector(getNewEstimateValues())


  const { estimate } = newEstimate
  const contacts = estimate?.properties?.contacts
    ? estimate.properties.contacts
    : []

  const [email, setEmail] = useState(user.emailString || user.email?.[0]?.email || "")
  const [phone, setPhone] = useState(
    user.phone
      ? user.phone?.toString()
      : contacts[0]?.phone
        ? contacts[0].phone
        : ''
  )

  const { showWarnings, saveNewValue, setCanGoForward } =
    useStepperContext()

  const validate: boolean =
    (PHONE_MASK_REGEXP_NO_SCOPE.test(phone) || PHONE_MASK_REGEXP.test(phone)) &&
    !isEmpty(user.companyName) &&
    !isEmpty(email) &&
    validateEmail(email)

  useEffect(() => {
    setCanGoForward(validate)
  }, [validate, email, phone, user.companyName])

  return (
    <>
      <Grid item>
        <Typography variant="h5" className={classes.title}>
          Great, {user.firstName}!
        </Typography>
        <Typography align="center"> You’re almost done!</Typography>
      </Grid>
      <Grid item>
        <LinearProgress variant="determinate" value={70} />
      </Grid>
      <Grid container item spacing={2}>
        <Grid item xs={12} lg={6}>
          <TextFieldLabel
            label="Company Name"
            error={showWarnings && isEmpty(user.companyName?.trim())}
            onChange={(ev) => {
              saveNewValue('companyName', ev.target.value)
            }}
            value={user.companyName}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextFieldLabel
            label="Company Zip Code"
            onChange={(ev) => {
              saveNewValue('address', { zipCode: ev.target.value })
            }}
            value={user?.address?.zipCode || ''}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextFieldLabel
            label="Your Email Address"
            onChange={(ev) => {
              setEmail(ev.target.value)
              saveNewValue(
                'emailString',
                ev.target.value
              )
            }}
            value={email}
            error={
              showWarnings &&
              (isEmpty(email) || !validateEmail(email))
            }
            placeholder="email@email.com"
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextFieldLabel
            label="Your Mobile Phone Number"
            onChange={(ev) => {
              setPhone(ev.target.value)
              saveNewValue(
                'phone',
                parseInt(ev.target.value?.replaceAll('-', ''))
              )
            }}
            mask={PHONE_MASK_INPUT}
            value={phone}
            error={
              showWarnings &&
              (isEmpty(phone) ||
                !(
                  PHONE_MASK_REGEXP.test(phone) ||
                  PHONE_MASK_REGEXP_NO_SCOPE.test(phone)
                ))
            }
            placeholder="123-123-1234"
          />
        </Grid>
        {/* {!isInstitutional && <Grid item xs={12} lg={6}>
          <Typography className={classes.label}>
            Are you a NAR member?
          </Typography>
          <RadioGroup
            value={user.nar || false}
            onChange={(e: ChangeEvent<HTMLInputElement>) => saveNewValue('nar', e.target.value === 'true')}
            className={classes.radioContainer}
          >
            <FormRadioButton
              style={user.nar === true ? { borderColor: "var(--bosscat-blue-600)" } : {}}
              value={true}
              control={<Radio color='primary' />}
              label={<Typography variant='caption'>Yes</Typography>} className={classes.radio}
            />
            <FormRadioButton
              style={user.nar === false ? { borderColor: "var(--bosscat-blue-600)" } : {}}
              value={false}
              control={<Radio color='primary' />}
              label={<Typography variant='caption'>No</Typography>} className={classes.radio}
            />
          </RadioGroup>
        </Grid>} */}
        <Grid item>
          <BottomLink
            question="Already have an account?"
            linkText="Sign in here"
            className={classes.marginBottom}
            onClick={() => {
              push('login')
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Company
